import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
    standalone: false,
    templateUrl: "./horizontalDateInput.component.html",
})
export class FormlyHorizontalDateInput extends FieldType<FieldTypeConfig> {
    maxDate: Date;
    minDate: Date;
    defaultDate = new Date();
    styleClass: string;
    format: string = "yy-mm-dd";
    monthNavigator: boolean = false;
    years: any[] = [];
    selectedMonth = 0;
    selectedYear = new Date().getFullYear();
    yearRange: string;

    ngOnInit() {
        for (
            let i = new Date().getFullYear() - 20;
            i < new Date().getFullYear() + 20;
            i++
        ) {
            this.years.push({ label: i, value: i });
        }

        if (
            this.model[this.key as string] &&
            typeof this.model[this.key as string] != typeof Object
        ) {
            const date = new Date(this.model[this.key as string]);
            this.model[this.key as string] = date;
        }

        this.selectedMonth = new Date(
            this.model[this.key as string] || new Date()
        ).getMonth();
        this.selectedYear = new Date(
            this.model[this.key as string] || new Date()
        ).getFullYear();

        if (this.props.min) this.minDate = new Date(this.props.min);

        if (this.props.max) this.maxDate = new Date(this.props.max);

        if (this.props) {
            if (this.props.maxDate !== undefined) this.maxDate = this.props.maxDate;

            if (this.props.minDate !== undefined) this.minDate = this.props.minDate;

            if (this.props.format) this.format = this.props.format;

            if (this.props.monthOnly) this.monthNavigator = this.props.monthOnly;

            this.yearRange = (this.props.yearRange) ? this.props.yearRange : this.getDefaultYearRange();
        }

        // p-calendar blanks its display when the value falls outside min/max by full timestamp, not
        // by day. Values are stored shifted by the timezone offset (e.g. today 01:00 in BST), so with
        // "no future dates" (max = today 00:00) a picked "today" vanished after a page switch.
        // Widen the limits to whole days - which days are selectable is unchanged.
        if (this.maxDate) {
            this.maxDate = new Date(this.maxDate);
            this.maxDate.setHours(23, 59, 59, 999);
        }

        if (this.minDate) {
            this.minDate = new Date(this.minDate);
            this.minDate.setHours(0, 0, 0, 0);
        }

        if (this.props.disabled) this.styleClass = "disabled form-control";
        else this.styleClass = "form-control";

        if (("" + this.formControl.value).length > 10) {
            var currentValue = new Date(this.formControl.value);
            this.formControl.setValue(
                new Date(
                    currentValue.getTime() -
                    currentValue.getTimezoneOffset() * 60000
                )
            );
        }
    }

    selectionMade($event) {
        if ($event === "Invalid Date") $event = new Date();
        this.formControl.setValue(
            new Date($event.getTime() - $event.getTimezoneOffset() * 60000)
        );
        this.markChanged();
        if (this.props.change) this.props.change(this);
    }

    dateSelected(selectedYear, selectedMonth) {
        const date = new Date(selectedYear, selectedMonth, 1);
        this.formControl.setValue(
            new Date(date.getTime() - date.getTimezoneOffset() * 60000)
        );
        this.markChanged();
        if (this.props.change) this.props.change(this);
    }

    // The calendar binds to model via ngModel, not to the form control, so the control never
    // learned it had been clicked into or changed. Without this a Date field didn't count as
    // interacted with for page validation, and never showed its required error.
    markTouched() {
        this.formControl.markAsTouched();
        this.field.options?.detectChanges?.(this.field);
    }

    // The clear button only empties model[key]; mirror it into the form control.
    cleared() {
        this.formControl.setValue(null);
        this.markChanged();
        if (this.props.change) this.props.change(this);
    }

    private markChanged() {
        this.formControl.markAsDirty();
        this.formControl.markAsTouched();
        this.field.options?.detectChanges?.(this.field);
    }

    getStyleClass = () => this.styleClass + " p-0";

    months: any[] = [
        { label: "January", value: 0 },
        { label: "February", value: 1 },
        { label: "March", value: 2 },
        { label: "April", value: 3 },
        { label: "May", value: 4 },
        { label: "June", value: 5 },
        { label: "July", value: 6 },
        { label: "August", value: 7 },
        { label: "September", value: 8 },
        { label: "October", value: 9 },
        { label: "November", value: 10 },
        { label: "December", value: 11 },
    ];

    private getDefaultYearRange(): string {
        const currentYear = new Date().getFullYear();
        return `${currentYear - 10}:${currentYear + 10}`;
    }
}
